export enum PubSubTopics {
    ORDER_PLACED = 'order-placed',
    NOTIFICATION_CREATED = 'notification-created',
  }